export function populateFormWithJson(form, json)
{
  for (var name in json) {
    let element = document.getElementById(form).elements[name];

    if (element !== undefined) {
      let value = json[name];
      let elementType = element.tagName.toLowerCase();

      if (elementType === 'hidden') {
        element.value = value;
      }

      if (elementType === 'input') {
        element.value = value;
      }

      if (elementType === 'textarea') {
        element.value = value;
      }

      if (elementType === 'select') {
        if (element.multiple) {
          let values = element.options;
          for (let i = 0; i < values.length; i++) {
            values[i].selected = value.includes(parseInt(values[i].value));
          }
        } else {
          element.value = value;
        }
      }
    }
  }
}

export function getHighestOccurenceInArray(arr) {
  return arr.sort((a,b) =>
    arr.filter(v => v===a).length - arr.filter(v => v===b).length
  ).pop();
}
